<div class="au-table-container">
	@if (isLoadingResults) {
		<div class="spinner-wrapper">
			<mat-spinner diameter="60"></mat-spinner>
		</div>
	}
	<div class="au-table-data" [class.d-none]="isLoadingResults">
		@if (isDataAndConfigProvided) {
			<div class="au-table-wrapper">
				<div class="scroll-x-auto nice-scroll colored-scroll-track visible-scroll">
					<ng-content select="[table-layout]"></ng-content>
				</div>
				<ng-content />
			</div>
		} @else {
			@if (!isFilteringApplied) {
				<au-empty-placeholder
					(buttonClicked)="emptyPlaceholderActionClicked()"
					[title]="emptyPlaceholderData.title"
					[description]="emptyPlaceholderData.description"
					[descriptionClass]="emptyPlaceholderData.descriptionClass || 'no-data'"
					[buttonText]="emptyPlaceholderData.buttonText"
					[iconName]="emptyPlaceholderData.iconName"
					[width]="emptyPlaceholderData.width || 305"
					[placeholderPath]="
						emptyPlaceholderData.placeholderPath ||
						'./assets/img/maskot/no-work-entity.svg'
					"
				></au-empty-placeholder>
			} @else {
				<au-empty-placeholder
					[title]="
						'no_entities_to_show' | translate: { type: tableDataTypeName | translate }
					"
					placeholderPath="./assets/img/no_entities.svg"
					width="250"
				></au-empty-placeholder>
			}
		}
	</div>
</div>
